import * as types from './types';

const INITIAL_STATE = {
  report: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.PARTICIPATION_REPORT_LOADING:
      return {
        ...state,
        loading: payload,
        loadingMessage: 'Loading Report',
      };

    case types.PARTICIPATION_REPORT_GET_REPORT:
      return {
        ...state,
        report: payload,
      };

    case types.PARTICIPATION_REPORT_CLEAR_REPORT:
      return { ...state, report: null, error: null };

    case types.PARTICIPATION_REPORT_ERROR:
      return {
        ...state,
        error: payload,
        loadingMessage: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/participation/state/report/reducer.js